<script setup lang="ts">
import LoadingSpin from "@/components/icons/LoadingSpin.vue";

interface Props {
  onClick?: () => void;
  onKeydown?: (e: KeyboardEvent) => void;
  label?: string;
  disabled?: boolean;
  loading?: boolean;
}

withDefaults(defineProps<Props>(), {
  onClick: () => {},
  onKeydown: () => {},
  color: "#1F2937",
  disabled: false,
  loading: false,
});
</script>

<script lang="ts">
export default {
  name: 'StyledButton'
}
</script>

<template>
  <button
    @click="onClick"
    @keydown="onKeydown"
    :class="[
      'button flex items-center gap-2 fade-transition w-fit py-[0.438rem] px-2 rounded-md justify-center hover:bg-[#4b6ec0] hover:text-white transition-colors duration-300 ease-in-out',
      disabled && 'cursor-not-allowed bg-[#6380ac]',
    ]"
    :disabled="disabled"
  >
    {{ label }}

    <template v-if="!label">
      <slot />
    </template>

    <template v-if="loading">
      <LoadingSpin />
    </template>
  </button>
</template>

<style scoped></style>
